function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56",
  transform: "translate(-450 -128)",
  fill: "#2794f2"
}, React.createElement("rect", {
  "data-name": "Rectangle 51",
  width: 30,
  height: 3,
  rx: 1.5,
  transform: "translate(450 128)"
}), React.createElement("rect", {
  "data-name": "Rectangle 52",
  width: 20,
  height: 3,
  rx: 1.5,
  transform: "translate(460 136)"
}), React.createElement("rect", {
  "data-name": "Rectangle 53",
  width: 30,
  height: 3,
  rx: 1.5,
  transform: "translate(450 144)"
}));

function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 30 19",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _ref2);
}

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAxOSI+CiAgPGcgaWQ9Ikdyb3VwXzU2IiBkYXRhLW5hbWU9Ikdyb3VwIDU2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDUwIC0xMjgpIj4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfNTEiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDUxIiBzdHlsZT0iZmlsbDogIzI3OTRmMiIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ1MCAxMjgpIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzUyIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA1MiIgc3R5bGU9ImZpbGw6ICMyNzk0ZjIiIHdpZHRoPSIyMCIgaGVpZ2h0PSIzIiByeD0iMS41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NjAgMTM2KSIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV81MyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNTMiIHN0eWxlPSJmaWxsOiAjMjc5NGYyIiB3aWR0aD0iMzAiIGhlaWdodD0iMyIgcng9IjEuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUwIDE0NCkiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };